/**
 * The agency's contact details. ONE definition, referenced everywhere.
 *
 * The app used to ship two different phone numbers: (562) 402-1737 on the
 * marketing pages and (562) 809-1234 throughout the dashboard's help and error
 * copy. So roughly half the app told clients to call a number the agency does
 * not answer -- including the "something went wrong" and claims-help paths,
 * where a wrong number does the most damage.
 *
 * (562) 402-1737 is the correct number for every build.
 *
 * Never hardcode a phone number or support address in a component. Import
 * these. A second literal phone number appearing in a diff is a regression.
 */

export const AGENCY_PHONE_DISPLAY = '(562) 402-1737';

/** Ready for an href. Includes the `tel:` scheme. */
export const AGENCY_PHONE_TEL = 'tel:+15624021737';

export const AGENCY_EMAIL = 'info@pinoygeneralinsurance.com';

/** Ready for an href. Includes the `mailto:` scheme. */
export const AGENCY_EMAIL_MAILTO = 'mailto:info@pinoygeneralinsurance.com';
